<template>
  <div id="zp">
    <div class="map">
        <vl-map :load-tiles-while-animating="true" :load-tiles-while-interacting="true"
          data-projection="EPSG:4326"
        >
      <vl-view :zoom.sync="zoom" :center.sync="center" :rotation.sync="rotation"></vl-view>

      <vl-geoloc @update:position="geolocPosition = $event">
        <template slot-scope="geoloc">
          <vl-feature v-if="geoloc.position" id="position-feature">
            <vl-geom-point :coordinates="geoloc.position"></vl-geom-point>
            <vl-style-box>
              <vl-style-icon src="_media/marker.png" :scale="0.4" :anchor="[0.5, 1]"></vl-style-icon>
            </vl-style-box>
          </vl-feature>
        </template>
      </vl-geoloc>
      <vl-layer-tile id="osm" opacity="0.3">
        <vl-source-osm></vl-source-osm>
      </vl-layer-tile>
      <vl-layer-vector>
        <vl-source-vector :features.sync="features"></vl-source-vector>

        <vl-style-box>
          <vl-style-stroke color="rgba(200,50,50,1)" :width="2"></vl-style-stroke>
          <vl-style-fill color="rgba(200,50,50,0.6)"></vl-style-fill>
        </vl-style-box>
      </vl-layer-vector>
      <!-- <vl-layer-tile>
        <vl-source-xyz url="https://tmscache.luucy.ch/4851c813-918d-4fc4-beec-803e9441beac/{z}/{x}/{-y}.png"></vl-source-xyz>
      </vl-layer-tile> -->
    </vl-map>
    </div>
    <div class="table">
      <template>
        <v-data-table
          :headers="tabledata.headers"
          :items="tabledata.values"
          class="datatable"
          :loading="loading"
          :disable-pagination="disablePagination"
          :hide-default-footer="disablePagination"
          fixed-header
          @item-selected="tableItemClick"
          single-select
          height="450px"
        >
          <!-- <template v-slot:item.istbz="{ item }">
          </template> -->
          <template
            v-slot:body="{ items }"
          >
            <tbody>
              <tr
                v-for="item in items"
                :key="item.bezeichn"
              >
                <td
                  v-for="(key, name) in item"
                  :key="key"
                >
                  <div v-if="key.type === 'boolean'" class="centered">
                  <v-simple-checkbox
                    v-if="key.type === 'boolean'"
                    v-model="key.value"
                    :disabled="!key.editable"
                    @input="attributeChange(item)"
                  ></v-simple-checkbox>
                  </div>
                  <!-- <input class="simpleTableInput" v-if="key.type === 'text' && key.editable" :value="key.value"/> -->
                  <v-text-field
                    v-if="key.type === 'text' && key.editable"
                    v-model="key.value"
                    :rules="textRules"
                    filled
                    dense
                    hide-details
                    @change="attributeChange(item)"
                  ></v-text-field>
                  <v-text-field
                    v-if="key.type === 'number' && key.editable"
                    v-model="key.value"
                    :rules="numberRules"
                    filled
                    dense
                    hide-details
                    :suffix="attributeSuffix(name, item)"
                    @change="attributeChange(item)"
                  ></v-text-field>
                  <span v-if="key.type === 'text' && !key.editable">{{key.value}}</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </template>
    </div>
    <div v-if="editingBlocked" class="docisnotready">
      <div v-if="!isDataReady" class="nodata">
        <p>Gültiger Datensatz ist noch nicht Verfügbar.</p>
        <p>Bitte lade <router-link to="/">hier </router-link> einen gültigen Datensatz hoch.</p>
      </div>
      <Loader v-if="loading" />
    </div>
  </div>
</template>

<script>
import InputFileService from '@/services/InputFile'
import Loader from '@/components/Loader.vue'

export default {
  name: 'zoningplan',
  mounted () {
    this.refreshInputFileData()
  },
  updated () {
    // this.refreshInputFileData()
  },
  data () {
    return {
      isDataReady: false,
      editingBlocked: true,
      disablePagination: true,
      loading: true,
      tabledata: {headers: [], values: []},
      unitId: this.$unit.uuid,
      fileId: -1,
      zoom: 14,
      center: [8.312634, 46.987279],
      rotation: 0,
      status: '',
      type: this.$route.params.type,
      numberRules: [
        value => (value && value >= 0)
      ],
      textRules: [
        value => (value && value.length >= 1)
      ],
      features: []
    }
  },
  watch: {
    $route: function (to, from) {
      this.tabledata = {headers: [], values: []}
      this.status = ''
      this.loading = true
      this.isDataReady = false
      this.type = this.$route.params.type
      this.editingBlocked = true
      this.refreshInputFileData()
    },
    status: function (val) {
      switch (val) {
        case 'OPEN' :
          this.isDataReady = false
          this.editingBlocked = true
          break
        case 'PROGRESS':
          this.isDataReady = true
          this.editingBlocked = true
          this.loading = true
          break
        case 'ERROR':
          this.isDataReady = false
          this.editingBlocked = true
          break
        case 'LOADING':
          this.isDataReady = true
          this.editingBlocked = true
          this.loading = true
          break
        case 'VALID':
          this.isDataReady = true
          this.editingBlocked = false
          this.loading = false
          break
      }
    }
  },
  components: {
    Loader
  },
  methods: {
    tableItemClick (item) {
      // console.log('TTT', item)
    },
    async attributeChange (item) {
      const itemEntries = Object.entries(item)

      const itemValues = {}
      for (const key of itemEntries) {
        itemValues[key[0]] = key[1].value
      }

      await InputFileService.inputFileSaveRowDetails(this.fileId, itemValues)
      // console.log(responce)
    },
    attributeSuffix (keyName, item) {
      const f = this.tabledata.headers.find(e => {
        return e.value === keyName
      })

      if (f) {
        if (f.format) {
          console.log(f.format.suffix)
          return f.format.suffix
        } else {
          return null
        }
      } else {
        return null
      }
    },
    async refreshInputFileData () {
      this.loading = true
      const responce = await InputFileService.inputfiledetails({
        unitId: this.unitId,
        docType: this.type
      })
      // console.log(responce.data)
      const r = responce.data
      this.loading = false
      this.status = r.status
      this.fileId = r.fileId

      // map values an headers to fill missing values and sort entrys like in headers
      let _values = []
      this.features = []
      for (let i = 0; i < r.data.values.length; i++) {
        _values[i] = {}
        this.features.push({
          type: 'Feature',
          id: i,
          geometry: r.data.values[i].__geometry
        })
        for (let j = 0; j < r.data.headers.length; j++) {
          _values[i][r.data.headers[j].value] = {value: r.data.values[i][r.data.headers[j].value], type: r.data.headers[j].type, editable: r.data.headers[j].editable}
        }
      }
      this.center = r.data.center
      this.tabledata = r.data
      this.tabledata.values = _values
      // console.log(_values)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {padding: 0 4px !important;}
h1, h2 {
  font-weight: normal;
}
.map {
    position: absolute;
    top: 0;
    bottom: 450px;
    left: 0;
    right: 0;
}
.table {
    height: 450px;
    overflow: hidden;
    border-top: 1px;
    padding-top: 5px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}
#zp {
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
}
.docisnotready {
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.8;
  position: absolute;
  text-align: center;
  vertical-align: middle;
  padding-top: 20%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
}
.simpleTableInput {
  padding: 5px;
  margin-left: -5px;
}
.centered {
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/views/InputFile.vue